import { PropsWithChildren } from 'react'

import { useRegisterSW } from 'virtual:pwa-register/react'

export default function PwaProvider({ children }: PropsWithChildren) {
  useRegisterSW({
    immediate: true
  })

  return children
}
